import { useLocation } from "react-router-dom";
import SEO from "./SEO";
import { defaultGuestMeta, defaultLoggedInMeta, routeMeta } from "./seoConfig";

export default function GlobalSeo() {
    const location = useLocation();

    const token = localStorage.getItem("access_token");

    const defaultMeta = token
        ? defaultLoggedInMeta
        : defaultGuestMeta;
    const meta =
        routeMeta[location.pathname] ||
        defaultMeta;
    return (
        <SEO
            title={meta.title}
            description={meta.description}
            keywords={meta.keywords}
        />
    );
}